import { render } from "./AboutUsPage.vue?vue&type=template&id=417361b7&scoped=true"
import script from "./AboutUsPage.vue?vue&type=script&lang=js"
export * from "./AboutUsPage.vue?vue&type=script&lang=js"

import "./AboutUsPage.vue?vue&type=style&index=0&id=417361b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-417361b7"]])

export default __exports__